module.exports = __webpack_public_path__ + "static/fonts/TikTokSans-Regular.6e41b688.ttf";